import Image from 'next/image';

import cn from '@/lib/clsxm';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Card from '@/components/@base/card';
import Container from '@/components/@base/container';
import { CONTAINER_TAG_TYPE } from '@/components/@base/container/type';
import { Heading, Text } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import XImage from '@/components/@base/x-image';
import Medals from '@/components/shared/components/medals';

import imagesList from '@/constant/images-list';
import StoreModel from '@/models/store.model';

type StoreBannerProps = Pick<StoreModel, 'cover' | 'medals' | 'logo' | 'name' | 'slogan'>;

export default function StoreBanner({ cover, medals, logo, name, slogan }: StoreBannerProps) {
  return (
    <Card
      noShadow
      noBorder
      className={cn('relative flex min-h-[338px] flex-1 rounded-none md:rounded-xl')}
    >
      <Image
        src={cover.publicLink}
        alt={cover.title}
        fill
        className='h-full w-full object-cover brightness-50 md:rounded-none'
      />
      <Container
        type={CONTAINER_TAG_TYPE.DIV}
        className='z-10 flex flex-1 px-4 md:grid md:grid-rows-[1fr_3fr_1fr] md:px-20'
      >
        <div />
        <Container
          type={CONTAINER_TAG_TYPE.DIV}
          className='my-5 flex flex-1 flex-col items-center justify-evenly md:my-0 md:flex-row md:items-end md:justify-between'
        >
          <Container
            type={CONTAINER_TAG_TYPE.DIV}
            className='flex flex-col items-center justify-evenly text-white md:mt-0 md:items-start'
          >
            <Container className='relative h-[91px] w-[91px] md:right-[-30px] md:h-[109px] md:w-[109px]'>
              <XImage
                className={cn('rounded-full border-2 border-white')}
                alt={logo?.title || name}
                fill
                src={logo?.publicLink || imagesList.icons.zhkSmGrayLogo}
              />
            </Container>
            <Heading
              type={HEADING_TYPE.H1}
              className='pt-4 text-[24px] leading-9 font-bold tracking-tighter md:pt-6'
            >
              {name}
            </Heading>
            <Text
              type={TEXT_TYPE.P}
              size={SIZE_ENUM.MD}
              className='inline-block bg-linear-to-r from-[#FFC107] to-[#FF7B01] bg-clip-text leading-6 font-bold tracking-tighter text-transparent'
            >
              {slogan}
            </Text>
          </Container>

          <Medals medals={medals} className='grid grid-cols-7 md:flex' />
        </Container>
      </Container>
    </Card>
  );
}
